import { MetaCollectionRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaCollectionRenderer';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { BigPicklistInput, HeadlineTextMedium } from 'Packages/FacetDesign/Components';
import InvestorProfileSectionLayout from './InvestorProfileSectionLayout';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('memberEnrolled', {
    _component: () => BigPicklistInput,
  }, overrideReadOnly)
  .nameOverride('title', {
    _component: () => HeadlineTextMedium,
    _customProps: {
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .done();

const Content = ({
  collection,
  onSubmit,
}) => {
  return (
    <MetaCollectionRenderer
      collection={collection}
      layout={InvestorProfileSectionLayout}
      onSubmit={onSubmit}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

Content.defaultProps = {
};
Content.propTypes = {
  collection: PropTypes.instanceOf(fr.Resource).isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export { Content };
